export default store => {
	if (_isAuth) {
		const iframeV2 = typeof _iframe_v2 !== "undefined" ? _iframe_v2 : false;
		const ssoHideMenu = typeof _sso_hide_menu !== "undefined" ? _sso_hide_menu : false;
		store.dispatch('core-iframe/set', iframeV2 || ssoHideMenu);
		store.dispatch('core-sso/set', ssoHideMenu);

		store.dispatch('core-menu/set', _menu);
		store.dispatch('core-company-menu/set', _companyMenu);
		store.dispatch('core-footer/set', _footer);
		store.dispatch('core-header/set', _header);
		store.dispatch('user/set', _user);
	};
	
	store.dispatch('data/set', _data);
	store.dispatch('request/set', { _error, _alert, _form });
};
